// Backend paths whose 401 must not force a logout. Shared by collectiveApi and the window.fetch wrapper.
// rest-auth/refresh-token/ is excluded because refreshToken() in useAuthHandlers
// already handles 401 on the refresh endpoint — letting the response interceptor
// also force-logout causes a double-logout race condition.
// rest-auth/logout/ is excluded because a 401 during logout is expected when the
// token is already invalid — triggering forceLogoutRedirect would be redundant.
// ai/ endpoints proxy to a third-party (Decagon) integration. A 401 from those
// reflects an integration-level failure, not a dead Collective session, so it
// must not tear down the user's auth. Backstop for the BE returning the wrong
// status; works whether the BE returns 401 or 502.
// gusto/sdk/ proxies the Gusto SDK and passes Gusto's 401 through when the grant is revoked,
// which means "reconnect Gusto", not an expired session.
const LOGOUT_EXEMPT_ENDPOINTS = [
    'rest-auth/login/',
    'rest-auth/login/code/',
    'rest-auth/login/resend-code/',
    'rest-auth/refresh-token/',
    'rest-auth/logout/',
    'ai/signature/decagon',
    'ai/member/conversations',
    'ai/agent-assist/',
    'gusto/sdk/',
];

export default LOGOUT_EXEMPT_ENDPOINTS;
